import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import qs from 'query-string';

const TOKEN_NAME = 'NorthAmerican_SSGap_TOKEN';

export default class Auth {
  constructor({ SSO_URL }) {
    this.authUrl = SSO_URL;
  }

  isAuthenticated() {
    const token = this.getToken();
    const isAuthenticated = token && !this.isTokenExpired(token);
    return process.env.REACT_APP_SAML_ENABLED === 'true' ? isAuthenticated : true;
  }

  isTokenExpired(token) {
    let isTokenExpired;
    try {
      const { exp } = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      isTokenExpired = exp < currentTime;
    } catch (err) {
      isTokenExpired = true;
    }
    return isTokenExpired;
  }

  getDataLayer(token) {
    return jwtDecode(token);
  }

  setToken(token) {
    if (token) {
      sessionStorage.setItem(TOKEN_NAME, token);
    }
  }

  getToken() {
    let token;

    try {
      const parsedURL = qs.parse(window.location.search);
      token = parsedURL.token || null;
    } catch (error) {
      const params = new URLSearchParams(window.location.search);
      token = params.get('token') || null;
    }

    this.setToken(token);

    const jwtToken = token || sessionStorage.getItem(TOKEN_NAME);

    return jwtToken === null || _.isEmpty(jwtToken) ? null : jwtToken;
  }

  logout() {
    sessionStorage.removeItem(TOKEN_NAME);
  }

  redirectToLogin() {
    const currentPath = window.location.href;
    window.location.href = `${this.authUrl}${currentPath}`;
  }

  tryTriggerRefresh() {
    window.parent.postMessage('Get new access token', '*');
  }
}
